
import React from 'react';
import { motion } from 'framer-motion';
import { Control } from 'react-hook-form';
import { RegistrationFormValues } from '@/schemas/registrationSchema';
import { ContributionFields } from '@/components/registration';

interface ContributionSectionProps {
  control: Control<RegistrationFormValues>;
}

const ContributionSection: React.FC<ContributionSectionProps> = ({ control }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.5, duration: 0.5 }}
    >
      <ContributionFields control={control} />
    </motion.div>
  );
};

export default ContributionSection;
